export class BiondQuizEvents {
  constructor(biondQuizInterface, biondMealGlobalInterface) {
    this.biondQuizInterface = biondQuizInterface;
    this.biondMealGlobalInterface = biondMealGlobalInterface;
    this.init();
    
  }

  init() {
    // Step 1 (meal_types)
    document.querySelectorAll('.selection_meal_type input[type="radio"]').forEach(input => {
      input.addEventListener('change', e => {
        this.biondMealGlobalInterface.mealTypeIds = [];
        this.biondMealGlobalInterface.mealTypeIds.push(e.target.value);
        this.biondQuizInterface.updateBoxes();
        this.biondMealGlobalInterface.updateUrl();
        this.biondQuizInterface.initProducts();
      });
    });

    // Step 2 (side_dishs)
    document.querySelectorAll('.selection_side_dish input[type="radio"]').forEach(input => {
      input.addEventListener('change', e => {
        
        this.biondMealGlobalInterface.sideDishIds = [];
        this.biondMealGlobalInterface.sideDishIds.push(e.target.value);
        this.biondQuizInterface.updateBoxes();
        this.biondMealGlobalInterface.updateUrl();
        this.biondQuizInterface.initProducts();
      });
    });
    // Step 2 (side_dishs)
    document.querySelectorAll('.quiz_products input[type="radio"]').forEach(input => {
      input.addEventListener('change', e => {
        this.biondQuizInterface.activeMealVariant = e.target.value;
        this.biondMealGlobalInterface.totalMealsCount = parseInt(e.target.dataset.total);
        this.biondMealGlobalInterface.activeMealPrice = e.target.dataset.price;
        this.biondMealGlobalInterface.activeMealPriceValue = e.target.dataset.priceValue;
        this.biondMealGlobalInterface.activeBoxProductId = e.target.value;
        this.biondMealGlobalInterface.activeBoxVariantId = e.target.dataset.variantId;
        this.biondMealGlobalInterface.activeMealName = e.target.dataset.name;
        this.biondMealGlobalInterface.checkAndUpdateBoxSize();
        this.biondMealGlobalInterface.renderBoxInfos();
        this.biondMealGlobalInterface.getSellingPlans();
        this.biondMealGlobalInterface.updateSaveButton();

        //this.updateProducts();
        //this.updateUrl();
      });
    });
    // Delegation: Listener an die UL hängen
    document.addEventListener('click', e => {
      
      // Prüfen ob auf ein LI in .selling-plan-selection .options geklickt wurde
      const clickedLi = e.target.closest('.selling-plan-selection .options li');
      if (!clickedLi) return; // kein passendes Element

      const dropdown = clickedLi.closest('.selling-plan-selection');
      const selectedOption = dropdown.querySelector('.selected-option');

      // Text in selected-option schreiben
      selectedOption.textContent = clickedLi.textContent;

      // active-Klasse setzen
      dropdown.querySelectorAll('.options li').forEach(item => item.classList.remove('active'));
      clickedLi.classList.add('active');

      // Dropdown schließen
      dropdown.classList.remove('active');

      // SellingPlanId setzen
      this.biondMealGlobalInterface.selectedSellingPlanId =
        clickedLi.dataset.sellingPlan.replace("gid://shopify/SellingPlan/", "");
    });

    document.querySelector('.back-choosen-meal').addEventListener('click', e => {
      this.biondMealGlobalInterface.container.classList.remove('show-buy-step');
    });

    document.querySelector('.selling-plan-wrap .dropdown .selected-option').addEventListener('click', e => {
      const dropdown = e.target.closest('.dropdown');
      if (dropdown) {
        dropdown.classList.toggle('active');
      }
    });
    document.querySelector('.selling-plan-wrap .add-to-cart').addEventListener('click', e => {
        const subscriptionRadio = document.querySelector('#subscription');
        const onceRadio = document.querySelector('#sellingplan-once');

        // Prüfen ob ein Radio aktiv ist
        if (!subscriptionRadio.checked && !onceRadio.checked) {
          showAlert(`Bitte wähle eine Bestelloption aus.`, 'success');
          return;
        }

        // Wenn Subscription gewählt ist → prüfen ob ein Plan aktiv ist
        if (subscriptionRadio.checked) {
          const activePlan = document.querySelector('.selling-plan-selection .options li.active');
          if (!activePlan) {
            showAlert(`Bitte wähle ein Abo aus.`, 'success');
            return;
          }
          // Hier kannst du den Wert auslesen:
          const sellingPlanId = activePlan.dataset.sellingPlan;
          console.log('Gewählter Plan:', sellingPlanId);
        }

      const btn = e.currentTarget;
      btn.disabled = true;
      this.biondQuizInterface.add_cart();
    });

    document.querySelector('.fill-automatically').addEventListener('click', e => {
      this.biondQuizInterface.fillAuto();
    });
    document.querySelector('.remove-all-products').addEventListener('click', e => {
      this.biondQuizInterface.resetProductChoice();
        //this.biondQuizInterface.updateBoxes();
      this.biondMealGlobalInterface.updateUrl();
        
    })

    

   

    document.querySelectorAll(".filter-meal-type label, .filter-side-dish label").forEach(trigger => {
      trigger.addEventListener("click", function() {
        // das li über das label finden
        const li = this.closest("li");

        // alle li-Elemente innerhalb des Containers zurücksetzen
        li.parentElement.querySelectorAll("li").forEach(el => el.classList.remove("active"));

        // das aktuelle li aktiv setzen
        li.classList.add("active");

        // den ausgewählten Wert ermitteln (z.B. Text des Labels)
        const selectedValue = this.textContent.trim();

        // im nächstgelegenen .custom-filter-quiz das .selected-filter-quiz finden
        const container = this.closest(".custom-filter-quiz");
        const output = container.querySelector(".selected-filter-quiz");

        if (output) {
          output.textContent = selectedValue;
        }
        container.classList.remove('active-dropdown')
      });
    });

  }

  

  
}
